import React, { Suspense } from 'react';

import { ReactFCC } from '@types';

interface ILoadableRouteProps {
  skeletonComponent: React.FunctionComponent;
  component: React.FunctionComponent;
}
export const LoadableRoute: ReactFCC<ILoadableRouteProps> = ({ component, skeletonComponent }) => {
  const Component = component;
  const SkeletonComponent = skeletonComponent;
  return (
    <Suspense fallback={<SkeletonComponent />}>
      <Component />
    </Suspense>
  );
};
